import * as React from "react";
import { useRouteError } from "react-router-dom";
import { Box, Button, Container, Paper, Stack, Typography } from "@mui/material";

// Router-level fallback: react-router renders this in place of the route that
// threw, so it must not depend on anything the crash may have left broken.
// Keeping the copy in Spanish also keeps Chrome from treating the page as
// English and auto-translating it, which is what mangled the original report.
export default function AppErrorPage() {
  const error = useRouteError();
  const detail = error?.stack || error?.message || "";

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper elevation={1} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h5" component="h1" gutterBottom>
          Algo salió mal
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          No pudimos mostrar esta página. Puedes recargar e intentarlo de nuevo;
          si el problema continúa, comunícate con soporte.
        </Typography>

        <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
          <Button variant="contained" onClick={() => window.location.reload()}>
            Recargar la página
          </Button>
          <Button variant="outlined" href="/home">
            Ir al inicio
          </Button>
        </Stack>

        {detail && (
          <Box component="details" sx={{ mt: 3 }}>
            <Box
              component="summary"
              sx={{ cursor: "pointer", color: "text.secondary", fontSize: "0.85rem" }}
            >
              Detalle técnico
            </Box>
            <Box
              component="pre"
              translate="no"
              sx={{
                mt: 1,
                p: 1.5,
                borderRadius: 1,
                bgcolor: "grey.100",
                fontSize: "0.7rem",
                whiteSpace: "pre-wrap",
                overflowX: "auto",
              }}
            >
              {detail}
            </Box>
          </Box>
        )}
      </Paper>
    </Container>
  );
}
